import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@fluentui/react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';
import { endActivity } from '../../shared/util';

const HashingInstructions = ({ hashingInstructions }) => {
  const hashingPhoneNumber = (
    <ReactTemplate
      template={hashingInstructions[0]}
      model={{
            e164: text => <a href="https://en.wikipedia.org/wiki/E.164" target="_blank" rel="noopener noreferrer">{text}</a>,
          }}
    />
  );
  const hashingEmail = hashingInstructions[1];
  const hasingEmailDetail = hashingInstructions.slice(2);

  return (
    <ul className="hashing-instructions">
      <li>{hashingPhoneNumber}</li>
      <li>{hashingEmail}</li>
      <ul>
        {hasingEmailDetail.map((detail, index) =>
          // eslint-disable-next-line react/no-array-index-key
          <li key={`hashing-instruction-${index}`}>{detail}</li>)}
      </ul>
    </ul>
  );
};
const InsertInstructionUnstyled = (props) => {
  const {
    classes,
    i18n,
    template,
    logActivity,
    wizardDispatch,
    permissions,
    hashingInstructions,
  } = props;

  const enhancedConversions = permissions.dynamic && permissions.dynamic.EnhancedConversions;
  const goToEmailTagPage = useCallback(() => {
    endActivity(logActivity);
    wizardDispatch({
      type: WIZARD_ACTIONS.GO_TO_EMAIL_DEVELOPER_STEP,
    });
  }, [logActivity, wizardDispatch]);

  const sendToDevLink = i18n.getString(_TL_('send these instructions to a developer'));

  return (
    <div className={classNames('insert-instruction')} style={{ maxWidth: '50%' }}>
      <div className={classes.instructionsHeader}>
        <b>{i18n.getString(_TL_('Instructions:'))}</b>
      </div>
      <div className={classNames(classes.bodyText)}>
        <p className="notranslate">
          <ReactTemplate
            template={template.join(hashingInstructions ? '{{newline}}{{/newline}}' :
            '{{newline}}{{/newline}}{{newline}}{{/newline}}')}
            model={{
            newline: () => <br />,
            b: text => (<b>{text}</b>),
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            a: () => (enhancedConversions ? sendToDevLink : <Link onClick={goToEmailTagPage} onKeyDown={goToEmailTagPage} role="button" tabIndex={0}>{sendToDevLink}</Link>),
            hashingInstructions: () => (hashingInstructions ? <HashingInstructions i18n={i18n} hashingInstructions={hashingInstructions} /> : null),
      }}
          />
        </p>
      </div>
    </div>
  );
};

InsertInstructionUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  template: PropTypes.arrayOf(PropTypes.string).isRequired,
  logActivity: PropTypes.shape({}).isRequired,
  wizardDispatch: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      EnhancedConversions: PropTypes.bool,
    }),
  }),
};

InsertInstructionUnstyled.defaultProps = {
  permissions: {
    dynamic: {
      EnhancedConversions: false,
    },
  },
};

export const InsertInstruction = withDefaultStyles(InsertInstructionUnstyled, getStepStyles);
